import React, { useMemo, useState, useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { truncate } from "lodash";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenuNew";

export default function XFilterDropDown({
  list,
  selectedFilters,
  setSelectedFilters,
  totalSelectedFilterAmount,
  setTotalSelectedFilterAmount,
}) {
  const feedAuthorList = useMemo(() => {
    return list.reduce((acc, item) => {
      if (!acc.some((author) => author.username === item.username)) {
        acc.push(item);
      }
      return acc;
    }, []);
  }, [list]);

  const handleReset = () => {
    setSelectedFilters([]);
  };

  return (
    <PopperMenu
      type="filter"
      anchorAlign={"end"}
      selectedItems={selectedFilters}
      setSelectedItems={setSelectedFilters}
      totalSelectedAmount={totalSelectedFilterAmount}
      setTotalSelectedAmount={setTotalSelectedFilterAmount}
      showMenuListTitle={true}
      onMenuTitleButtonClick={handleReset}
      menuItemGroup={[
        {
          menuItemId: "kol",
          menuItemTitle: "KOL",
          menuItems: feedAuthorList.map((item) => ({
            value: item.name,
            label: (
              <Box display="flex" alignItems="center">
                <img
                  src={item.image}
                  width={24}
                  height={24}
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                  alt={item.name}
                />
                <Box ml="9px">
                  <Box mr="4px" fontSize={12} color="#555" fontWeight={700}>
                    {truncate(item.name, { length: 15 })}
                  </Box>
                  <Box fontSize="10px" color="#777">
                    @{truncate(item.username, { length: 15 })}
                  </Box>
                </Box>
              </Box>
            ),
          })),
          canMultiSelect: true,
          onClick: (selected) => console.log("KOL Selected:", selected),
        },
      ]}
    />
  );
}
